/**
 * @file Strips the currency formatting from a dollar amount string.
 */
const DOLLAR_SIGN = "$";
const THOUSANDS_SEPARATOR_REGEX = /,/g;

/**
 * Strips the dollar sign and thousands separators from a formatted currency string.
 */
const getAmountValueFromCurrency = (value: string): string => {
  const amount = value
    .replace(DOLLAR_SIGN, "")
    .replace(THOUSANDS_SEPARATOR_REGEX, "");

  return amount;
};

export default getAmountValueFromCurrency;
